/**
 * api接口统一管理
 */
import { get, post, postExport } from './http';

const link = {

  /**
   * 基础信息
   * @param {*} p
   * @returns
   */

  // 用户管理
  userLogin: p => post('/user/login', p),//登录
  userExit: p => post('/user/exit', p),//注销
  userUpdatePwdCurr: p => post('/user/updatePwdCurr', p),//更改当前账号密码


  userInsert: p => post('/user/insert', p),//添加用户信息
  userQuery: p => get('/user/query', p),//查询用户
  userQueryList: p => get('/user/queryList', p),//查询用户列表
  userStatus: p => post('/user/status', p),//更改用户状态
  userUpdate: p => post('/user/update', p),//更新用户信息
  userUpdatePwd: p => post('/user/updatePwd', p),//更改密码

  // 部门管理
  depAdd: p => post('/department/add', p),//增
  depDelete: p => post('/department/delete', p),//删
  depUpdate: p => post('/department/update', p),//改
  depStatus: p => post('/department/status', p),//改状态
  depAllSearch: p => get('/department/queryAll', p),//查全部
  depSearch: p => post('/department/queryList', p),//查

  // 角色管理
  roleAdd: p => post('/roles/add', p),//增
  roleDelete: p => post('/roles/delete', p),//删
  roleUpdate: p => post('/roles/update', p),//改
  roleSearch: p => get('/roles/queryList', p),//查
  roleStatus: p => post('/roles/status', p),//改状态
  roleMenu: p => post('/roles/menu', p),//更新角色菜单

  // 菜单管理
  menuAdd: p => post('/menu/add', p),//增
  menuDelete: p => post('/menu/delete', p),//删
  menuUpdate: p => post('/menu/update', p),//改
  menuAllSearch: p => get('/menu/queryAll', p),//查全部
  menuSearch: p => post('/menu/queryList', p),//查
  menuStatus: p => post('/menu/status', p),//改状态
  sysPlatformQueryAll: p => post('/base/sysPlatform/queryAll', p),//全部平台

  // 消息列表
  msgAdd: p => post('/base/message/add', p),//增
  msgDelete: p => post('/base/message/delete', p),//删
  msgDisable: p => post('/base/message/disable', p),//禁用消息
  msgEnable: p => post('/base/message/enable', p),//启用消息
  msgQueryList: p => get('/base/message/queryList', p),//分页查
  msgUpdate: p => post('/base/message/update', p),//按主键更新消息
  msgDetail: p => get('/base/message/detail', p),//消息详情

  /**
   * 商品信息
   * @param {*} p
   * @returns
   */
  // 品牌管理
  brandAdd: p => post('/product/brand/add', p),//增
  brandDelete: p => post('/product/brand/delete', p),//删
  brandUpdate: p => post('/product/brand/update', p),//改
  brandSearch: p => get('product/brand/queryList', p),//查
  brandAll: p => get('/product/brand/queryAll', p),//全部品牌
  brandEnable: p => post('/product/brand/enable', p),//启用
  brandDisable: p => post('/product/brand/disable', p),//禁用
  brandSort: p => post('/product/brand/updateSort', p),//禁用

  // 类目管理
  categoryAdd: p => post('/product/category/add', p),//增
  categoryDelete: p => post('/product/category/delete', p),//删
  categoryUpdate: p => post('/product/category/update', p),//改
  categorySearch: p => get('product/category/queryList', p),//查
  categoryAll: p => get('/product/category/queryAll', p),//全部类目
  categoryEnable: p => post('/product/category/enable', p),//启用
  categoryDisable: p => post('/product/category/disable', p),//禁用

  // 属性管理
  propertyAdd: p => post('/product/property/add', p),//增
  propertyDelete: p => post('/product/property/delete', p),//删
  propertyUpdate: p => post('/product/property/update', p),//改
  propertySearch: p => get('product/property/queryList', p),//查
  propertyEnable: p => post('/product/property/enable', p),//启用
  propertyDisable: p => post('/product/property/disable', p),//禁用

  // SPU管理
  spuAdd: p => post('/product/spu/add', p),//增
  spuDelete: p => post('/product/spu/delete', p),//删
  spuUpdate: p => post('/product/spu/update', p),//改
  spuSearch: p => get('product/spu/queryList', p),//查
  spuEnable: p => post('/product/spu/enable', p),//启用
  spuDisable: p => post('/product/spu/disable', p),//禁用
  spuDetail: p => get('/product/spu/queryDetail', p),//详情


  // SKU管理
  skuAdd: p => post('/product/sku/add', p),//增
  skuDelete: p => post('/product/sku/delete', p),//删
  skuUpdate: p => post('/product/sku/update', p),//改
  skuSearch: p => get('product/sku/queryList', p),//查
  skuEnable: p => post('/product/sku/enable', p),//启用
  skuDisable: p => post('/product/sku/disable', p),//禁用
  skuDetail: p => get('/product/sku/queryDetail', p),//详情

  // SKU平台管理
  platformAdd: p => post('/product/sku/platform/add', p),//增
  platformDelete: p => post('/product/sku/platform/delete', p),//删
  platformUpdate: p => post('/product/sku/platform/update', p),//改
  platformSearch: p => get('product/sku/platform/queryList', p),//查

  // 标签管理
  labelAdd: p => post('/product/label/add', p),//增
  labelDelete: p => post('/product/label/delete', p),//删
  labelUpdate: p => post('/product/label/update', p),//改
  labelSearch: p => get('product/label/queryList', p),//查
  labelPage: p => get('product/label/queryPage', p),//分页查
  labelEnable: p => post('/product/label/enable', p),//启用
  labelDisable: p => post('/product/label/disable', p),//禁用

  // SKU价格管理
  priceAdd: p => post('/product/sku/price/add', p),//增
  priceDelete: p => post('/product/sku/price/delete', p),//删
  priceUpdate: p => post('/product/sku/price/update', p),//改
  priceSearch: p => get('product/sku/price/queryList', p),//查
  spGroupQueryAll: p => get('/base/spGroup/queryAll', p),


  // 资金商仓库信息
  wareAdd: p => post('/wms/base/add', p),//增
  wareUpdate: p => post('/wms/base/update', p),//改
  wareUpdateArea: p => post('/wms/base/updateArea', p),//改覆盖区域
  wareSearch: p => get('/wms/base/queryList', p),//查
  wareSearchArea: p => get('/wms/base/queryArea', p),//覆盖区域
  wareDetail: p => get('/wms/base/queryDetail', p),//详情
  wareSync: p => post('/wms/base/syncSku', p),//同步SKU信息
  wareVagueSearch: p => get('/wms/base/queryWms', p),//下拉框查询所有仓库，根据仓库名模糊查询
  batchImport: p => post('/wms/base/batchImport', p),//批量导入仓库
  batchExport: p => get('/wms/base/export', p),//导出仓库
  wareDisable: p => post('/wms/base/disable', p),//仓库禁用
  wareEnable: p => post('/wms/base/enable', p),//仓库启用


  // 资金商&服务商管理
  spAdd: p => post('/shop/spInfo/add', p),//增
  spQuery: p => get('/shop/spInfo/query', p),//查
  spSearchAll: p => get('/shop/spInfo/queryAll', p),//查全部
  spSearch: p => post('/shop/spInfo/queryList', p),//分页查
  spUpdate: p => post('/shop/spInfo/update', p),//改

  // 行政区划省份城市
  areaQuery: p => get('/base/area/query', p),//查
  areaQueryAll: p => get('/base/area/queryAll', p),//查

  // 资金商仓库渠道信息
  baseChannel: p => get('/wms/channel/baseChannel', p),//渠道基础列表查询(Grade Group)
  queryChannelList: p => get('/wms/channel/queryChannelList', p),//仓库渠道列表查询
  queryProvinceArea: p => get('/wms/channel/queryProvinceArea', p), //仓库支持的省份
  batchUpdateChannel: p => post('/wms/channel/batchUpdateChannel', p), //批量设置仓库渠道
  splitDelete: p => post('/wms/channel/updateChannel', p),//设置仓库渠道

  // 采购单拆分权重
  splitDelete: p => post('/wms/order/split/delete', p),//删
  splitDisable: p => post('/wms/order/split/disable', p),//禁用
  splitEnable: p => post('/wms/order/split/enable', p),//启用
  splitImport: p => post('/wms/order/split/importFile', p),//导入
  splitSearch: p => get('/wms/order/split/queryList', p),//查
  templateFile: p => get('/base/template/fileUrl', p),//获取模板文件Url

  // 采购单生成
  purchCreate: p => post('/wms/purchaseOrder/opt/create', p),//创建
  purchExamine: p => post('/wms/purchaseOrder/opt/examine', p),//审核
  purchUpdate: p => post('/wms/purchaseOrder/opt/update', p),//修改
  purchDetail: p => get('/wms/purchaseOrder/query/detail', p),//查询明细
  purchSearch: p => get('/wms/purchaseOrder/query/list', p),//查询列表
  purchSkuList: p => get('/wms/purchaseOrder/querySkuList', p),//查询采购单的库存

  // SKU管理
  productSkuSpQueryList: p => get('/product/sku/spQueryList', p),//查询资金商SKU列表

  //   资金商仓位/库存
  batchAddSkuNum: p => post('/wms/inv/batchAddSkuNum', p),//批量增加仓库商品库存
  batchUpdateStatus: p => post('/wms/inv/batchUpdateStatus', p),//批量修改仓库商品编码、上下架状态
  invDisable: p => post('/wms/inv/disable', p),//下架
  invEnable: p => post('/wms/inv/enable', p),//上架
  queryInvList: p => get('/wms/inv/queryInvList', p),//库存盘点查询
  searchInvList: p => get('/wms/inv/queryList', p),//服务商仓库商品查询
  updateInv: p => post('/wms/inv/updateInv', p),//提交盘点
  updateSpErpCode: p => get('/wms/inv/updateSpErpCode', p),//设置经销商商品编码

  // 资金商分组
  groupAdd: p => post('/base/spGroup/add', p),//增
  groupQuery: p => get('/base/spGroup/query', p),//查
  groupSearch: p => post('/base/spGroup/queryList', p),//分页查
  groupUpdate: p => post('/base/spGroup/update', p),//改

  // 资金商覆盖区域
  spAreaUpdate: p => post('/shop/spArea/updateArea', p),//设置
  spAreaQuery: p => get('/shop/spArea/queryList', p),//分页查
  spAreaSearch: p => get('/shop/spArea/queryBySpCode', p),//查询覆盖区域-Tree

  // 配额管理
  allocImport: p => post('/alloc/import', p),//配额导入
  allocProvince: p => post('/alloc/province/queryList', p),//省份配额查询
  allocRetailer: p => post('/alloc/retailer/queryList', p),//门店配额查询
  allocRetailerGroup: p => post('/alloc/retailerGroup/queryList', p),//客户集团配额查询
  allocShipTo: p => post('/alloc/shipTo/queryList', p),//仓库配额查询

  //任务管理
  scheduleAllTask: p => get('/schedule/job/data', p), //任务列表查询
  addScheduleTask: p => post('/schedule/job/save', p), //新增任务
  editScheduleTask: p => post('/schedule/job/update', p), //编辑任务
  resumeScheduleTask: p => post('/schedule/job/resume?jobId=' + p), //重启任务
  pauseScheduleTask: p => post('/schedule/job/pause?jobId=' + p), //暂停任务
  runScheduleTask: p => post('/schedule/job/run?jobId=' + p), //运行任务
  deleteScheduleTask: (path, p) => post('/schedule/job/remove/' + path, p), //删除任务

  //优惠券
  couponTemplateType: p => post('/coupon/queryCouponTemplateType', p),//查询优惠券类型
  couponTemplateStatus: p => post('/coupon/queryCouponTemplateStatus', p), //查询优惠券模板列表
  couponqueryBusiPlatform: p => post('/coupon/queryBusiPlatform', p),//查询优惠券业务平台
  queryCouponTemplatelist: p => post('/coupon/queryCouponTemplatelist', p),//查询优惠券模板列表
  createCouponTemplate: p => post('/coupon/createCouponTemplate', p),//创建优惠券模板
  updateCouponTemplate: p => post('/coupon/updateCouponTemplate', p),//修改优惠券模板
  queryTemplateDetail: p => post('/coupon/queryTemplateDetail', p),//查询优惠券模板详情
  disableCouponTemplate: p => post('/coupon/disableCouponTemplate', p),//停用优惠券模板
  activeCouponTemplate: p => post('/coupon/activeCouponTemplate', p),//启用优惠券模板
  createCouponApplyByTemplate: p => post('/coupon/createCouponApplyByTemplate', p),//创建优惠券发放申请
  updateCouponApply: p => post('/coupon/updateCouponApply', p),//创建优惠券发放申请
  queryCouponApplyList: p => post('/coupon/queryCouponApplyList', p),//查询优惠券发放申请
  queryCouponApplySim: p => post('/coupon/queryCouponApplySim', p),//查询优惠券发放申请
  queryCouponScopeByApplyCode: p => post('/coupon/queryCouponScopeByApplyCode', p),//查询优惠券发放范围
  queryCouponScopeList: p => post('/coupon/queryCouponScopeList', p),//查询优惠券发放范围明细
  auditCouponApply: p => post('/coupon/auditCouponApply', p),//审批优惠券发放申请
  cancelCouponApply: p => post('/coupon/cancelCouponApply', p),//取消优惠券发放申请
  realeaseCouponApply: p => post('/coupon/realeaseCouponApply', p),//发放优惠券发放申请
  recallCouponApply: p => post('/coupon/recallCouponApply', p),//优惠券撤回
  rejectCouponApply: p => post('/coupon/rejectCouponApply', p),//优惠券拒审
  queryCouponDistriblist: p => post('/coupon/queryCouponDistriblist', p),//查询优惠券列表
  changeCouponDistribStatusExpired: p => post('/coupon/changeCouponDistribStatusExpired', p),//更改优惠券状态为已过期
  saveCouponBusiCtl: p => post('/coupon/saveCouponBusiCtl', p),//保存优惠券规则设置
  queryCouponBusiCtl: p => post('/coupon/queryCouponBusiCtl', p),//查询优惠券规则设置
  queryCouponScopeIssueRule: p => post('/coupon/queryCouponScopeIssueRule', p),//查询优惠券发放规则枚举
  batchImportRet: p => post('coupon/batchImportRet', p),//批量导入门店及发放数量


  // 门店管理
  baseRetailerType: p => get('/base/retailerType/query', p),
  baseRetailerTypQqueryAll: p => get('/base/retailerType/queryAll', p),
  baseRetailerTypeList: p => post('/base/retailerType/queryList', p),
  wmsBaseQueryList: p => get('/wms/base/queryList', p),
  shopInfoEnable: p => post('/shop/info/enable', p),
  shopInfoQueryList: p => post('/shop/info/queryList', p),
  shopInfoQuery: p => get(`/shop/info/query`, p),
  baseAreaQueryAll: p => get('/base/area/queryAll', p),
  queryForShop: p => get('/base/area/queryForShop', p),
  shopInfoAdd: p => post('/shop/info/add', p),
  shopInfoUpdate: p => post('/shop/info/update', p),
  shopAddressAdd: p => post('/shop/address/add', p),
  shopAddressUpdate: p => post('/shop/address/update', p),
  shopInfoAudit: p => post('/shop/info/audit', p),
  retailerGroupQueryList: p => post('/base/retailerGroup/queryList', p),
  userTypeQueryAll: p => get('/base/userType/queryAll', p),
  shopInfoQueryParent: p => get('/shop/info/queryParent', p),
  retailerTypeQueryList: p => post('/base/retailerType/queryList', p),
  channelInfoqQueryList: p => post('/base/channelInfo/queryList', p),
  switchStatus: p => get('/shop/info/switchStatus', p),

  // 等级信息
  gradeAdd: p => post('/base/gradeInfo/add', p),//添加等级
  gradeDelete: p => post('/base/gradeInfo/delete', p),//删除用户分类
  gradeDisable: p => post('/base/gradeInfo/disable', p),//添加等级
  gradeEnable: p => post('/base/gradeInfo/enable', p),//启用
  gradeSearchAll: p => get('/base/gradeInfo/queryAll', p),//查询所有
  gradeSearch: p => get('/base/gradeInfo/queryList', p),//分页查询
  gradeUpdate: p => post('/base/gradeInfo/update', p),//更新等级

  // 等级分组信息
  gradeGroupAdd: p => post('/base/gradeGroup/add', p),//添加等级分组
  gradeGroupDelete: p => post('/base/gradeGroup/delete', p),//删除等级分组
  gradeGroupSearchAll: p => get('/base/gradeGroup/queryAll', p),//查询所有
  gradeGroupUpdate: p => get('/base/gradeGroup/update', p),//更新等级分组

  // 余额和返利
  balanceAudit: p => post('/shop/wall/balance/audit', p),//审核
  batchImportAccount: p => post('/shop/wall/balance/batchImportAccount', p),//批量导入账户金额
  batchImportRebate: p => post('/shop/wall/balance/batchImportRebate', p),//批量导入返利
  balanceSearch: p => get('/shop/wall/balance/queryList', p),//查询
  balanceImportSearch: p => get('/shop/wall/balance/queryImportList', p),//导入查询


  // SKU资金商管理
  productSkuQueryAll: p => get('/product/sku/queryList', p),
  spInfoQueryAll: p => get('/shop/spInfo/queryAll', p),
  skuSpQueryList: p => get('/product/sku/rule/queryList', p),
  skuRuleQueryDetail: p => get('/product/sku/rule/queryDetail', p),
  skuSpAdd: p => post('/product/sku/rule/add', p),
  skuSpUpload: p => post('/product/sku/rule/update', p),
  skuSpEnable: p => post('/product/sku/rule/enable', p),
  skuSpDisable: p => post('/product/sku/rule/disable', p),

  // 门店任务
  displayQueryList: p => get('/base/shopCheck/display/queryList', p),
  displayQueryDetail: p => get('/base/shopCheck/display/queryDetail', p),
  displayExamine: p => post('/base/shopCheck/display/examine', p),

  posQueryList: p => get('/base/shopCheck/pos/queryList', p),
  posQueryDetail: p => get('/base/shopCheck/pos/queryDetail', p),
  posExamine: p => post('/base/shopCheck/pos/examine', p),

  //datax
  getDataXTaskTemplateList: p => get('/datax/template/queryList', p),
  addDataXTaskTemplate: p => post('/datax/template/add', p),
  modifyDataXTaskTemplate: p => post('/datax/template/update', p),
  getDataXTaskTemplateDetail: p => get('/datax/template/queryByCode', p),
  enableDataXTaskTemplate: p => post('/datax/template/enable', p),
  disableDataXTaskTemplate: p => post('/datax/template/disable', p),

  submitDataXTask: p => post('/datax/instance/submit', p),
  getDataXTaskList: p => get('/datax/instance/queryList', p),
  getDataXDetail: p => get('/datax/instance/queryDetail', p),

  getOrderDeliveryList: p => post('/order/delivery/list', p),
  getOrderDeliveryDetail: p => post('/order/delivery/detail', p),
  exportOrderDelivery: p => post('/order/delivery/export', p),

  getReportSpMetaList: p => post('/sp/data/report/meta/list', p),
  addReportSpMeta: p => post('/sp/data/report/meta/add', p),
  modifyReportSpMeta: p => post('/sp/data/report/meta/modify', p),
  getReportSpMetaDetail: p => post('/sp/data/report/meta/detail', p),
  enableSkuReportSpMeta: p => post('/sp/data/report/meta/enable', p),
  disableSkuReportSpMeta: p => post('/sp/data/report/meta/disable', p),
  getSpAvailableList: p => post('/sp/data/report/meta/available', p),
  removeReportSpMeta: p => post('/sp/data/report/meta/remove', p),

  getSkuReportSpList: p => post('/sp/data/report/sku/list', p),
  batchSubmitSkuSellInList: p => post('/sp/data/report/sku/batch/sllIn', p),
  batchSubmitSkuOpeningStockList: p => post('/sp/data/report/sku/batch/openingStock', p),
  spSkuDataBuildReport: p => post('/sp/data/report/sku/build', p),

  submitReportSyncData: p => post('/sp/data/report/sku/sync', p),
  getReportSyncDataList: p => post('/sp/data/report/sku/sync/list', p),

  getAllSpSettleDateList: p => post('/sp/data/report/date/list', p),
  addSpSettleDate: p => post('/sp/data/report/date/add', p),
  modifySpSettleDate: p => post('/sp/data/report/date/modify', p),
  removeSpSettleDate: p => post('/sp/data/report/date/remove', p),

  getSpReportList: p => post('/sp/data/report/list', p),
  buildSpDataReport: p => post('/sp/data/report/build', p),

  getActualPartReportList: p => post('/inv/report/actual/list', p),
  uploadActualPartFile: p => post('/inv/report/actual/upload', p),

  getForecastPartReportList: p => post('/inv/report/forecast/list', p),
  uploadForecastPartFile: p => post('/inv/report/forecast/upload', p),

  getPsiReportList: p => post('/inv/report/psi/list', p),
  uploadPsiFile: p => post('/inv/report/psi/upload', p),

  getInvReportList: p => post('/inv/report/summary/data', p),
  getRetailInvReportList: p => post('/inv/report/summary/retailInv', p),
  getRetailInvDaysReportList: p => post('/inv/report/summary/retailInvDays', p),
  getSkuChartDataList: p => post('/inv/report/summary/charts', p),
  getSkuChartTableDataList: p => post('/inv/report/summary/chartDatas', p),

  getSkuInvSummaryList: p => post('/inv/report/summary/list', p),
  getSkuInvSummaryDetail: p => post('/inv/report/summary/query', p),
  modifySkuInvSummary: p => post('/inv/report/summary/modify', p),
  buildSkuInvSummary: p => post('/inv/report/summary/build', p),

  getInvReportMetaList: p => post('/inv/report/meta/list', p),
  addInvReportMeta: p => post('/inv/report/meta/add', p),
  getInvReportShortNameList: p => post('/inv/report/meta/shortName/list', p),
  addInvReportShortName: p => post('/inv/report/meta/shortName/add', p),
  getInvReportCategoryList: p => post('/inv/report/meta/category/list', p),
  addInvReportCategory: p => post('/inv/report/meta/category/add', p),

  getAvailableGradeSourceList: p => post('/inv/report/grade/sources', p),
  addInvGrad: p => post('/inv/report/grade/add', p),
  getInvGradeDetail: p => post('inv/report/grade/query', p),
  getInvGradeList: p => post('/inv/report/grade/list', p),
  addInvGradeMap: p => post('/inv/report/grade/map/add', p),

  getInvMetaGradeMapList: p => post('/inv/report/grade/map/list', p),
  getInvMetaGradeMapDetail: p => post('/inv/report/grade/map/query', p),
  removeInvMetaGradeMap: p => post('/inv/report/grade/map/remove', p),

  // 订单管理
  pushOrder: p => post('/order/opt/pushErp', p),//批量推送erp
  orderExport: p => post('/order/export', p),//导出订单列表

  // 资源位管理
  contentAdd: p => post('/content/add', p),//新增文章素材信息
  contentList: p => post('/content/list', p),//查询文章素材列表
  contentUpt: p => post('/content/modify', p),//编辑文章素材信息
  contentDel: p => post('/content/remove', p),//删除文章素材信息

  conTypeList: p => post('/content/type/list', p),//查询文章素材类型列表
  conTypeAdd: p => post('/content/type/add', p),//新增文章素材类型信息
  conTypeUpt: p => post('/content/type/modify', p),//编辑文章素材类型信息
  conTypeDel: p => post('/content/type/remove', p),//删除文章素材类型信息

  materialAdd: p => post('/content/material/add', p),//新增卖货素材信息
  materialList: p => post('/content/material/list', p),//卖货素材列表
  materialUpt: p => post('/content/material/modify', p),//编辑卖货素材信息
  materialDetail: p => post('/content/material/query', p),//查询卖货素材详情
  materialDel: p => post('/content/material/remove', p),//删除卖货素材详情

  maTypeList: p => post('/content/material/type/list', p),//查询卖货素材类型列表
  maTypeUpt: p => post('/content/material/type/modify', p),//编辑卖货素材类型
  maTypeDetail: p => post('/content/material/type/query', p),//查询卖货素材类型详情
  maTypeAdd: p => post('/content/material/type/add', p),//新增卖货素材类型
  maTypeDel: p => post('/content/material/type/remove', p),//删除卖货素材类型
  // 广告位管理
  sectionAll: p => post('/content/section/ads/all', p),//查询全部广告位板块枚举
  sectionList: p => post('/content/section/ads/list', p),//分页查询广告列表
  sectionAdd: p => post('/content/section/ads', p),//新增广告位配置
  sectionUpt: p => post('/content/section/ads/modify', p),//修改广告位配置
  sectionDel: p => post('/content/section/ads/remove', p),//删除广告位


  // 发票管理
  invoiceList: p => post('/invoice/info/queryPage', p),//分页查询
  invoiceApprove: p => post('/invoice/info/audit', p),//发票审核

  // 物料管理
  materManList: p => post('/material/queryList', p),//查询物料列表
  materManAdd: p => post('/material/addMaterial', p),//新增物料
  materManUpt: p => post('/material/modifyMaterial', p),//修改物料信息
  materManDetail: p => get('/material/queryDetailsByCode', p),//物料信息详情
  materManType: p => post('/material/getMaterialType', p),//物料类型种类
  materManExport: p => post('/material/export', p),//物料导出列表

  activationList: p => post('/materia/activation/queryList', p),//激活信息列表
  activationDetail: p => get('/materia/activation/queryDetailsByCode', p),//激活信息详情
  activationnExport: p => post('materia/activation/export', p),//激活导出列表


  scanList: p => post('/scanCode/queryList', p),//扫码记录信息列表
  scanDetail: p => get('/scanCode/queryDetailsByCode', p),//扫码记录详情
  scanExport: p => post('/scanCode/export', p),//扫码导出列表


  frmLossList: p => post('/frmLoss/queryList', p),//报损列表
  frmLossDetail: p => get('/frmLoss/queryDetailsByCode', p),//报损记录详情
  frmLossExport: p => post('/frmLoss/export', p),//报损列表导出

}
export default link;



// WEBPACK FOOTER //
// ./src/request/api.js